import type { PreflightOutput } from "@/src/lib/workflows/steps/preflight";

/**
 * Creates typed accessors for stashing tenant-specific data in PreflightOutput.customerData.
 *
 * @param key - Namespace key that isolates this tenant's data from others.
 * @param isT - Type guard that validates the raw value from customerData.
 * @returns Object with `build` (write) and `read` (read, returning null on miss/invalid) helpers.
 */
export function createCustomerDataAccessors<T>(key: string, isT: (x: unknown) => x is T) {
  return {
    build(data: T): Record<string, unknown> {
      return { [key]: data };
    },
    read(customerData: PreflightOutput["customerData"]): T | null {
      if (!customerData) return null;
      const raw = customerData[key];

      return isT(raw) ? raw : null;
    },
  };
}
